import { render, staticRenderFns } from "./client-fields.vue?vue&type=template&id=29839658&scoped=true"
import script from "./client-fields.vue?vue&type=script&lang=js"
export * from "./client-fields.vue?vue&type=script&lang=js"
import style0 from "./client-fields.vue?vue&type=style&index=0&id=29839658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29839658",
  null
  
)

export default component.exports